import { render, staticRenderFns } from "./autenticacao.vue?vue&type=template&id=15c95d28&"
import script from "./autenticacao.vue?vue&type=script&lang=ts&"
export * from "./autenticacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports